// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".altertClass[data-v-4a928d3d]{font-size:15px;font-weight:700;padding-left:5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
